'use client';

import React from 'react';
import { Carousel, Heading, CAROUSEL_ITEMS } from '@ui';
import { Section, Container } from '@layout';
import MarkupSnippet, { markupCopyLabels } from '../markup-snippet/MarkupSnippet';
import { withOptionalId } from '@lib/withOptionalId';

interface CarouselDemoProps {
  sectionID?: string;
  classes?: string;
  containerId?: string;
  containerClasses?: string;
  isSpanish?: boolean;
}

const CarouselDemo: React.FC<CarouselDemoProps> = ({
  isSpanish = false,
  sectionID = '',
  classes = '',
  containerId,
  containerClasses,
}) => {
  const t = (en: string, es: string) => (isSpanish ? es : en);

  const carouselItems = isSpanish
    ? CAROUSEL_ITEMS.map((item, i) => ({
        ...item,
        title: `Tarjeta de ejemplo ${i + 1}`,
        label: 'Imágenes de relleno / texto de ejemplo.',
      }))
    : CAROUSEL_ITEMS;

  return (
    <Section {...withOptionalId(sectionID)} className={classes}>
      <Container containerId={containerId} containerClasses={containerClasses}>
        <Heading as='h3'>{t('Horizontal Carousel', 'Carrusel horizontal')}</Heading>
        <p className='sub full'>
          {t(
            'Cards as image placeholders. Use the arrows or drag/scroll. Snaps per card.',
            'Tarjetas como marcadores de imagen. Usa las flechas o arrastra/desplaza. Se ajusta por tarjeta.'
          )}
        </p>
        <Carousel items={carouselItems} locale={isSpanish ? 'es' : 'en'} />
        <MarkupSnippet
          {...markupCopyLabels(isSpanish)}
          code={`<div class="carousel" data-carousel>
  <button class="carousel-btn prev" type="button" aria-label="Previous"></button>
  <div class="carousel-viewport">
    <article class="carousel-item card">Slide</article>
  </div>
  <button class="carousel-btn next" type="button" aria-label="Next"></button>
</div>`}
        />
      </Container>
    </Section>
  );
};

export default CarouselDemo;
